export const makePartnerImageUrl = (url: string | null | undefined): string =>
  url
    ? `https://talent.seek.com.au/static/partner-hub/${url.replace(
        'static/',
        '',
      )}`
    : '';
